export default __webpack_public_path__ + "b152f893a65c26688b577c0936d75d4a.png";